module.exports = __webpack_public_path__ + "img/facebook_icon-icons.com_59205.e44ebc92.svg";